import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Star, Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Textarea } from '@/components/ui/textarea';
import { useAvaliarOS } from '@/hooks/useConsumerOS';

export function AvaliarOSDialog({ osId, open, onOpenChange }: { osId: string; open: boolean; onOpenChange: (v: boolean) => void }) {
  const { t } = useTranslation();
  const avaliar = useAvaliarOS();
  const [nota, setNota] = useState(0);
  const [comentario, setComentario] = useState('');

  useEffect(() => { if (open) { setNota(0); setComentario(''); } }, [open]);

  const submeter = () => {
    if (nota < 1) return;
    avaliar.mutate({ osId, nota, comentario: comentario.trim() }, { onSuccess: () => onOpenChange(false) });
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader><DialogTitle>{t('myOrders.rateTitle')}</DialogTitle></DialogHeader>
        <div className="flex gap-1 justify-center py-2">
          {[1, 2, 3, 4, 5].map((n) => (
            <button key={n} type="button" onClick={() => setNota(n)} aria-label={`${n}`}>
              <Star className={`h-7 w-7 ${n <= nota ? 'fill-current text-yellow-500' : 'text-muted-foreground'}`} />
            </button>
          ))}
        </div>
        <Textarea value={comentario} onChange={(e) => setComentario(e.target.value)} placeholder={t('myOrders.commentPlaceholder')} rows={3} />
        <DialogFooter>
          <button type="button" className="ow-btn ow-btn--primary ow-btn--block" disabled={nota < 1 || avaliar.isPending} onClick={submeter}>
            {avaliar.isPending && <Loader2 className="h-4 w-4 animate-spin" />}
            {t('myOrders.submitRating')}
          </button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
